import { Box, Typography } from '@mui/material';
import { memo } from 'react';

/**
 * Coming Soon section header/divider
 *
 * @returns {React.ReactElement} Coming soon header component
 */
const ComingSoonHeader = memo(function ComingSoonHeader() {
  return (
    <Box
      sx={{
        mt: 8,
        borderTop: '4px solid var(--color-primary)',
        borderBottom: '4px solid var(--color-primary)',
        backgroundColor:
          'color-mix(in srgb, var(--color-primary) 5%, transparent)',
        py: 4,
        mb: 6,
      }}
    >
      <Typography
        variant="h3"
        sx={{
          color: 'var(--color-heading)',
          fontWeight: 600,
          fontSize: { xs: '2rem', md: '2.5rem' },
          fontFamily: '"Playfair Display", serif',
          textAlign: 'center',
        }}
      >
        Additional eBooks Coming Soon!
      </Typography>
    </Box>
  );
});

export default ComingSoonHeader;
